export default {
  "content": "<path d=\"M19 18.5a2 2 0 110 4 2 2 0 010-4z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.999 1.5C16.553 1.5 21 4.964 21 9.5a1 1 0 01-1.331.943c-2.557-.897-4.968-.903-6.67-.625V13.5H19a1 1 0 011 1V17h-2v-1.5H6V20h9.5v2H5a1 1 0 01-1-1v-5.5H2v-2h8.999v-3.231c-1.92.447-4.49.895-7.243.2A1 1 0 013 9.5c0-4.536 4.446-8 8.999-8zm.001 2c-3.427 0-6.438 2.379-6.93 5.196 2.52.408 4.84-.217 6.694-.668 1.705-.414 4.236-.596 7.022.076C18.006 5.554 15.184 3.5 12 3.5z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};